<template>

  <div>

    <BackButton v-if="$route.name !== 'users' && $route.name !== 'user-with-permit' && $route.name !== 'add-user-with-permit'" :namedRoutes="{ users: $t('nav.users'), user: $t('users.details')}"></BackButton>

    <add-edit-user-view v-if="$route.name !== 'user' && $route.name !== 'user-with-permit' && $route.name !== 'add-user-with-permit'"></add-edit-user-view>
    <user-details @isDeleted="(boolean) => {isDetailDeleted = boolean}" v-if="$route.name === 'user' || $route.name === 'user-with-permit' || $route.name === 'add-user-with-permit'" :selectedTenant="selectedTenant" v-on:selectedTenant="(tenantId) => { this.selectedTenant = tenantId }" ref="user"></user-details>
    <Permits v-if="!isDetailDeleted && ($route.name === 'user' || $route.name === 'user-with-permit' || $route.name === 'add-user-with-permit')" :selectedTenant="selectedTenant" ref="permits"></Permits>

    <BackButton v-if="$route.name !== 'users' && $route.name !== 'user-with-permit' && $route.name !== 'add-user-with-permit'" :namedRoutes="{ users: $t('nav.users'), user: $t('users.details')}"></BackButton>

  </div>

</template>

<script>
import BackButton from 'common/BackButton';
import AddEditUserView from './AddEditUserView';
import UserDetails from './UserDetails';
import Permits from './Permits';

export default {
  components: {
    BackButton,
    AddEditUserView,
    UserDetails,
    Permits,
  },
  data() {
    return {
      selectedTenant: null,
      isDetailDeleted: false,
    };
  },
};
</script>
<style lang="scss" scoped>
  @import '~styles/variables.scss';
  @import '~styles/blocks/details.scss';
  @import '~node_modules/leaflet/dist/leaflet.css';
</style>



// WEBPACK FOOTER //
// src/components/users/MainView.vue